import { getClassName } from '@onyx/ui/style-utils';

import styles from './avatar.module.css';

type AvatarStyle = 'primary' | 'secondary';
type AvatarColor =
  | 'neutral'
  | 'informative'
  | 'positive'
  | 'negative'
  | 'warning';

export type AvatarProps = {
  label: string;
  /** Style variant: primary | secondary */
  variant?: AvatarStyle;
  /** Color: neutral | informative | positive | negative | warning */
  color?: AvatarColor;
};

export const Avatar = ({
  label,
  variant = 'primary',
  color = 'neutral',
}: AvatarProps) => {
  const variantMap: Record<AvatarStyle, string> = {
    primary: styles.variantPrimary,
    secondary: styles.variantSecondary,
  };

  const colorMap: Record<AvatarColor, string> = {
    neutral: styles.colorNeutral,
    informative: styles.colorInformative,
    positive: styles.colorPositive,
    negative: styles.colorNegative,
    warning: styles.colorWarning,
  };

  const classNames = getClassName([
    styles.avatar,
    variantMap[variant],
    colorMap[color],
  ]);

  return <div className={classNames}>{label}</div>;
};
